export default {
  required: "This field is required",
  numeric: "This field may only contain numbers",
};
